(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bestselling-columns"] && !Shopify.designMode) return;
  try {
    
  window.addEventListener('DOMContentLoaded', function() {
    const carousels = document.querySelectorAll('.Bestselling_Columns__Wrapper');
    var instances = [];

    for (const carousel of carousels) {
      carousel.classList.remove('is-hidden');
      carousel.offsetHeight;
      instances.push(new Flickity(carousel, JSON.parse(carousel.dataset.flickitySettings)));
    }

    window.addEventListener('resize', function () {
      for (const instance of instances) {
        instance.resize();
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rao-marquee-black-friday"]) return;
  try {
    
  window.addEventListener('DOMContentLoaded', function() {
    createMarqueeInstance();
    document.addEventListener('shopify:section:load', function(e) {
      const sectionId = e.detail.sectionId;

      createMarqueeInstance(sectionId);
    });

    document.addEventListener('shopify:section:unload', function(e) {
      const sectionId = e.detail.sectionId;

      for (elem of window.marqueeInstances) {
        if (elem.id === sectionId) {
          elem.instance.clear();
          window.marqueeInstances.splice(window.marqueeInstances.indexOf(elem), 1);

          return;
        }
      }
    });

    function createMarqueeInstance(sectionId = null) {
      if (sectionId === null) {
        const containers = document.querySelectorAll(`[data-section-type="marquee"]`);
        containers.forEach(function(container) {
          const target = container.querySelector('.Marquee');

          setTimeout(function() {
            const marquee = new dynamicMarquee.Marquee(target, {
              rate: -50,
              startOnScreen: true
            });

            const marqueeLoop = new dynamicMarquee.loop(
              marquee,
              [
                function() {
                  return container.querySelector(`[data-content]`).innerHTML + ' ';
                }
              ]
            );

            window.marqueeInstances.push({
              'id': container.id.replace('section-', ''),
              'instance': marquee,
              'loop': marqueeLoop
            });
          }, 50);
        });
      } else {
        const container = document.querySelector(`#section-${ sectionId }`);
        const target = container.querySelector('.Marquee');
        let found = false;


        for (elem of window.marqueeInstances) {
          if (elem.id === sectionId && !found) {
            elem.loop.update([
              function() {
                return container.querySelector(`[data-content]`).innerHTML + ' ';
              }
            ]);

            found = true;
          }
        }

        if (!found) {
          setTimeout(function() {
            const marquee = new dynamicMarquee.Marquee(target, {
              rate: -50,
              startOnScreen: true
            });

            const marqueeLoop = new dynamicMarquee.loop(
              marquee,
              [
                function() {
                  return container.querySelector(`[data-content]`).innerText + ' ';
                }
              ]
            );

            window.marqueeInstances.push({
              'id': sectionId,
              'instance': marquee,
              'loop': marqueeLoop
            });
          }, 50);
        }
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rao-marquee"] && !Shopify.designMode) return;
  try {
    
  window.addEventListener('DOMContentLoaded', function() {
    createMarqueeInstance();
    
    document.addEventListener('shopify:section:load', function(e) {
      const sectionId = e.detail.sectionId;

      createMarqueeInstance(sectionId);
    });

    document.addEventListener('shopify:section:unload', function(e) {
      const sectionId = e.detail.sectionId;

      for (elem of window.marqueeInstances) {
        if (elem.id === sectionId) {
          elem.instance.clear();
          window.marqueeInstances.splice(window.marqueeInstances.indexOf(elem), 1);

          return;
        }
      }
    });

    function createMarqueeInstance(sectionId = null) {
      if (sectionId === null) {
        const containers = document.querySelectorAll(`[data-section-type="marquee"]`);
        containers.forEach(function(container) {
          const target = container.querySelector('.Marquee');

          setTimeout(function() {
            const marquee = new dynamicMarquee.Marquee(target, {
              rate: -50,
              startOnScreen: true
            });

            const marqueeLoop = new dynamicMarquee.loop(
              marquee,
              [
                function() {
                  return container.querySelector(`[data-content]`).innerHTML + ' ';
                }
              ]
            );

            window.marqueeInstances.push({
              'id': container.id.replace('section-', ''),
              'instance': marquee,
              'loop': marqueeLoop
            });
          }, 50);
        });
      } else {
        const container = document.querySelector(`#section-${ sectionId }`);
        const target = container.querySelector('.Marquee');
        let found = false;

        for (elem of window.marqueeInstances) {
          if (elem.id === sectionId && !found) {
            elem.loop.update([
              function() {
                return container.querySelector(`[data-content]`).innerHTML + ' ';
              }
            ]);

            found = true;
          }
        }

        if (!found) {
          setTimeout(function() {
            const marquee = new dynamicMarquee.Marquee(target, {
              rate: -50,
              startOnScreen: true
            });

            const marqueeLoop = new dynamicMarquee.loop(
              marquee,
              [
                function() {
                  return container.querySelector(`[data-content]`).innerText + ' ';
                }
              ]
            );

            window.marqueeInstances.push({
              'id': sectionId,
              'instance': marquee,
              'loop': marqueeLoop
            });
          }, 50);
        }
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-by-brand"] && !Shopify.designMode) return;
  try {
    
/*
  window.addEventListener('DOMContentLoaded', function () {
    const carousels = document.querySelectorAll('.ShopByBrand__Blocks');
    var isMobile = window.innerWidth < 641;
    var flickityInstances = [];

    for (const carousel of carousels) {
      const desktopFlkty = JSON.parse(carousel.dataset.flickitySettingsDesktop);
      const mobileFlkty = JSON.parse(carousel.dataset.flickitySettingsMobile);

      if (isMobile) {
        flickityInstances.push({
          element: carousel,
          instance: new Flickity(carousel, mobileFlkty)
        });
      } else {
        flickityInstances.push({
          element: carousel,
          instance: new Flickity(carousel, desktopFlkty)
        });
      }
    }

    window.addEventListener('resize', function () {
      const newWindowWidth = window.innerWidth;
      const newIsMobile = newWindowWidth < 641;

      for (const elem of flickityInstances) {
        elem.instance.resize();
      }

      if (newIsMobile !== isMobile) {
        isMobile = newIsMobile;

        for (const elem of flickityInstances) {
          flickityInstances.splice(flickityInstances.indexOf(elem), 1);
          elem.instance.destroy();

          const desktopFlkty = JSON.parse(elem.element.dataset.flickitySettingsDesktop);
          const mobileFlkty = JSON.parse(elem.element.dataset.flickitySettingsMobile);

          if (newIsMobile) {
            flickityInstances.push({
              element: elem.element,
              instance: new Flickity(elem.element, mobileFlkty)
            });
          } else {
            flickityInstances.push({
              element: elem.element,
              instance: new Flickity(elem.element, desktopFlkty)
            });
          }
        }
      } 
    });
  });
  */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stages-compare"] && !Shopify.designMode) return;
  try {
    
  window.addEventListener('DOMContentLoaded', function() {
    const carousels = document.querySelectorAll('.Stages_Compare__Wrapper');
    var instances = [];

    for (const carousel of carousels) {
      carousel.classList.remove('is-hidden');
      carousel.offsetHeight;
      instances.push(new Flickity(carousel, JSON.parse(carousel.dataset.flickitySettings)));
    }

    window.addEventListener('resize', function () {
      for (const instance of instances) {
        instance.resize();
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
